import React from 'react'
import imgLeft from './image/Header-img.png'

const HeaderLeft = () =>
{
    return (
        <div className="headerUp__left">
            <img src={imgLeft} alt='headerImg'></img>
        </div>
    )
}

export default HeaderLeft
